export const StandaloneCmsPartnerDecorator = {
  url() {
    return `signup/standalone-cms-partner`;
  },
  query() {
    return {};
  }
};